/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Weekly_PlanInputs */

const en_ui_labs_weekly_plan = /** @type {(inputs: Ui_Labs_Weekly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly Plan`)
};

const de_ui_labs_weekly_plan = /** @type {(inputs: Ui_Labs_Weekly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenplan`)
};

/**
* | output |
* | --- |
* | "Weekly Plan" |
*
* @param {Ui_Labs_Weekly_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_weekly_plan = /** @type {((inputs?: Ui_Labs_Weekly_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Weekly_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_weekly_plan(inputs)
	return de_ui_labs_weekly_plan(inputs)
});